import { useRef } from "react";
import { track } from "../../lib/events";
import { activeMilliseconds, activeSecondsSince } from "../../lib/activeTime";
import type { ContentItem } from "../../types";

// Records which one of several things (an image, a slide) the teacher is
// looking at, and how long they looked at the one before. The seconds are
// active seconds: time with the app hidden does not count. Looking at the
// same thing again does not repeat the event.
export function useViewTrail(item: ContentItem, moduleID: string, type: string, count: number) {
  const current = useRef<{ index: number; activeAt: number } | null>(null);
  return function viewed(index: number, by: string, extra: Record<string, unknown> = {}) {
    const previous = current.current;
    if (previous?.index === index) return;
    track(type, {
      module_id: moduleID,
      item_id: item.id,
      payload: {
        index,
        item_count: count,
        from_index: previous ? previous.index : null,
        previous_seconds: previous ? activeSecondsSince(previous.activeAt) : null,
        by,
        ...extra,
      },
    });
    current.current = { index, activeAt: activeMilliseconds() };
  };
}
